<template>
  <div class="projectInfo">
    <el-skeleton
      v-if="loading"
      :rows="3"
      animated
    />
    <el-card v-else-if="status === 'success'">
      <el-descriptions
        :title="$t('projectInfo.projectInformation')"
        direction="vertical"
        :column="4"
        :colon="false"
      >
        <el-descriptions-item :label="$t('projectInfo.projectName')">{{taskDetail.projectName}}</el-descriptions-item>
        <el-descriptions-item :label="$t('projectInfo.targetService')">
          <ul class="listWrapper">
            <li
              v-for="info in taskServiceInfo"
              :key="info"
            >{{info}}</li>
          </ul>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('projectInfo.projectCode')">
          <template v-if="projectCode.length > 0">
            <ul class="listWrapper">
              <li
                v-for="(code, index) in projectCode"
                :key="index"
              >
                <div>
                  {{code.fileName}}
                </div>
                <div
                  style="display: flex;"
                  v-if="code.sha256"
                >
                  {{code.sha256}}
                </div>
              </li>
            </ul>
          </template>
          <p v-else>{{ $t('projectInfo.notAvailable') }}</p>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('projectInfo.testAccounts')">
          <template v-if="testAccounts.length > 0">
            <ul class="listWrapper">
              <li
                v-for="(account, index) in testAccounts"
                :key="index"
              >{{account.roleName}}</li>
            </ul>
          </template>
          <p v-else>{{ $t('projectInfo.notAvailable') }}</p>
        </el-descriptions-item>
      </el-descriptions>
    </el-card>
  </div>
</template>

<script>
import { getTaskInfo } from '@/api/base';
import { RoleOptions } from '@/enum';

export default {
  name: 'ProjectInfo',
  props: {
    taskId: {
      type: String,
      required: true,
      status: 'success',
    },
  },
  data() {
    return {
      loading: false,
      taskDetail: {},
    };
  },
  computed: {
    taskServiceInfo() {
      const { params = {} } = this.taskDetail;
      const { originRequestData = {} } = params;
      const { sandboxHomePageUrl, sandboxTargetServiceUrl } = originRequestData;
      const result = [];

      if (sandboxHomePageUrl) {
        result.push(sandboxHomePageUrl);
      }

      if (sandboxTargetServiceUrl && sandboxTargetServiceUrl !== sandboxHomePageUrl) {
        result.push(sandboxTargetServiceUrl);
      }

      return result;
    },
    projectCode() {
      const { params = {} } = this.taskDetail;
      const { originRequestData = {} } = params;
      const { sourceCodeInfos = [], javaPackageFileName, javaPackage, primarySourceCode, primarySourceCodeFileName } = originRequestData;

      let result = sourceCodeInfos;

      if (primarySourceCode) {
        result.unshift({
          fileName: primarySourceCodeFileName,
          sha256: primarySourceCode,
        });
      } else {
        result.unshift({
          fileName: javaPackageFileName,
          sha256: javaPackage,
        });
      }

      return result.filter((item) => item.fileName);
    },
    testAccounts() {
      const { params = {} } = this.taskDetail;
      const { originRequestData = {} } = params;
      const { sandboxAuthInfos = [] } = originRequestData;

      return sandboxAuthInfos.map((item) => {
        const { roleName } = item;
        const realRoleName = RoleOptions.find((option) => option.value === roleName)?.label;

        return {
          ...item,
          roleName: realRoleName || roleName,
        };
      });
    },
  },
  created() {
    this.getTaskInfo();
  },
  methods: {
    getTaskInfo() {
      this.loading = true;

      getTaskInfo(this.taskId)
        .then((res) => {
          this.taskDetail = res;
          this.status = 'success';
          this.loading = false;
        })
        .catch(() => {
          this.status = 'error';
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.projectInfo {
  .el-descriptions-item__cell {
    vertical-align: baseline;
  }

  .listWrapper {
    margin-left: 15px;
    list-style: unset;
    padding: 0;

    li {
      margin-bottom: 10px;
    }
  }
}
</style>